import { useId } from 'react'

type Props = {
  /** Visible row label; used for the control's accessible name. */
  label: string
  /** Shown in the hover and focus popover. */
  text: string
}

/** Small info control: popover on hover and keyboard focus; keeps copy out of the main label line. */
export default function AboutYouInfoHint({ label, text }: Props) {
  const id = useId()

  return (
    <span className="group/info relative inline-flex shrink-0 align-middle">
      <button
        type="button"
        aria-describedby={id}
        aria-label={`More about ${label}`}
        className="inline-flex h-3.5 w-3.5 items-center justify-center overflow-hidden rounded-full p-0 text-on-surface-variant outline-none hover:text-primary-container focus-visible:ring-1 focus-visible:ring-primary-container/40"
      >
        <span
          className="material-symbols-outlined block leading-none"
          style={{
            fontSize: 12,
            fontVariationSettings: "'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24",
          }}
          aria-hidden
        >
          info
        </span>
      </button>
      <span
        id={id}
        role="tooltip"
        className="pointer-events-none invisible absolute left-1/2 top-full z-[100] mt-2 w-[min(22rem,calc(100vw-2rem))] -translate-x-1/2 rounded-md border border-outline-variant/30 bg-surface-container-highest px-3 py-2 text-left font-mono text-[10px] font-normal normal-case leading-relaxed tracking-normal text-on-surface opacity-0 shadow-xl transition-opacity duration-150 group-hover/info:visible group-hover/info:opacity-100 group-focus-within/info:visible group-focus-within/info:opacity-100"
      >
        {text}
      </span>
    </span>
  )
}
